import { LegrandGateway } from './LegrandGateway.model';
import { Operation } from '~/interfaces/device.interface';
import operations from '~/helpers/device-operations';

export class BPAC extends LegrandGateway {
    get deviceOperations(): Operation[]  {
        return super.deviceOperations.concat([
            operations.orderReboot({ callback: this.orderReboot, disabled: this.isOrderRebootDisabled }),
            operations.setDump({ callback: this.setDump }),
            operations.triggerLogsDump({ callback: this.triggerLogsDump }),
        ]);
    }
}
